import React from 'react';
import classnames from 'classnames';
import Dialog from '@ux/dialog';
import { transform } from './legacy';

const UX_ALERT_CLASSNAME = 'ux-alert';

function Alert(props) {
  const { children, emphasis, className, ...rest } = props;

  return (
    <Dialog
      role='alert'
      contrast={ true }
      emphasis={ emphasis }
      className={ classnames(UX_ALERT_CLASSNAME, className, {
        [`${UX_ALERT_CLASSNAME}--${emphasis}`]: emphasis && Dialog.ACCESSORIES[emphasis]
      }) }
      stretch={ true }
      { ...transform(rest) }>
      { children }
    </Dialog>
  );
}

Alert.propTypes = {
  ...Dialog.proptypes
};

export default Alert;
